var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconBuildTestingPipelines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.594 7.219-3-2.25a1 1 0 0 0-1.407.187 1 1 0 0 0 .188 1.407L16 7h-4V4.812c.875-.406 1.5-1.28 1.5-2.312C13.5 1.125 12.375 0 11 0a2.487 2.487 0 0 0-2.5 2.5c0 1.031.594 1.906 1.5 2.313V7H5V4.812c.875-.406 1.5-1.28 1.5-2.312C6.5 1.125 5.375 0 4 0a2.487 2.487 0 0 0-2.5 2.5c0 1.031.594 1.906 1.5 2.313V7H1c-.563 0-1 .469-1 1 0 .563.438 1 1 1h5v2.219c-.906.406-1.5 1.281-1.5 2.281C4.5 14.906 5.594 16 7 16c1.375 0 2.5-1.094 2.5-2.5 0-1-.625-1.875-1.5-2.281V9h8l-.625.469c-.438.312-.531.969-.188 1.406.188.25.5.375.813.375.188 0 .406-.063.594-.188l3-2.25A.992.992 0 0 0 20 8a.977.977 0 0 0-.406-.781zM11 1.5c.531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1zm-7 0c.531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1zm3 13c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconBuildTestingPipelines);
export default __webpack_public_path__ + "static/media/survey-icon-build-testing-pipelines.70f6f85d4e3dc88d24bba37a5ff6e848.svg";
export { ForwardRef as ReactComponent };